
import { defineComponent } from "vue";
import * as Lang from "@/i18n/lang";
import { getState } from "@/pinia/AppState";

export default defineComponent({
  setup() {
    return { Lang, state: getState() };
  },
});
